import { HttpBackend, HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnInit, ViewChild } from '@angular/core';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentService } from '../../services/component.service';
import { Apiservice } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Utenteservice } from '../../services/utente.service';
import { EditAutocompleteComponent } from '../edit-autocomplete/edit-autocomplete.component';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { alert } from 'devextreme/ui/dialog';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-editgiacenzainiziale',
  templateUrl: './editgiacenzainiziale.component.html',
  styleUrls: ['./editgiacenzainiziale.component.css']
})
export class EditgiacenzainizialeComponent implements OnInit, AfterViewInit {
  @ViewChild('sede', { static: false }) sede: EditAutocompleteComponent;
  @ViewChild('magazzino', { static: false }) magazzino: EditAutocompleteComponent;
  @ViewChild('eer', { static: false }) eer: EditAutocompleteComponent;
  @ViewChild('formGiacenzeIniziali', { static: false }) formGiacenzeIniziali: NicaFormComponent;
  //formGiacenzeIniziali
  @ViewChild('formGiacenzeInizialiFiltro', { static: false }) formGiacenzeInizialiFiltro: NicaFormComponent;

  @ViewChild('gridGiacenzeIniziali', { static: false }) gridGiacenzeIniziali: NicaAnagraficaComponent;
  //gridGiacenzeIniziali

  @Input() itemData: any
  @Input() guid: any
  @Input() ChiudiDopoModifica: boolean = false;
  filterKey
  myfilterDett
  insertRecord: boolean = false;
  buttonCustomFiltro: any[] = [];
  datiJson
  idDestinatario = 0
  idMagazzino = 0
  idCantiereFuoriUl = null;
  idPosizioneRifiuto = 0
  inEdit = false
  constructor(
    private httpClient: HttpClient,
    private _overlaySideFormService: OverlaySideFormService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private spinner: NgxSpinnerService,
    private userComponentService: ComponentService,
    private appService: Apiservice,
    private activatedroute: ActivatedRoute,
    private httpBackend: HttpBackend,
    private utenteSerivce: Utenteservice,
  ) {

  }
  ngAfterViewInit(): void {

    console.log(this.myfilterDett);
    this.sede.containerComponent = this;
    this.magazzino.containerComponent = this;
    this.eer.containerComponent = this;
    this.gridGiacenzeIniziali.refresh();
    // this.formGiacenzeIniziali.parent=this;
    //throw new Error('Method not implemented.');
  }
  SedeChanged() {

  }
  MagazzinoChanged() {

  }
  ngOnInit() {

    this.buttonCustomFiltro = [
      /*{
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'elabora',
        icon: "glyphicon fa fa-bolt",
        event: 'elaboraFiltro'
      },
      */
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Chiudi',
        icon: "glyphicon icon-annulla-form",
        event: 'elaboraFiltroChiudi'
      },
    ]


    this.myfilterDett = "?idDestinatario=0&idMagazzino=0&idPosizioneRifiuto=0&idCantiereFuoriUl=&load=true"
    if (this.itemData) {
      if (this.itemData.id != '' && this.itemData.id != undefined) {
        this.filterKey = "/" + this.itemData.id
        this.inEdit = true;
        this.ChiudiDopoModifica = this.itemData.ChiudiDopoModifica
      } else {
        this.datiJson = {
          idDestinatario: this.itemData.idDestinatario,
          idMagazzino: this.itemData.idMagazzino,
          idPosizioneRifiuto: this.itemData.idPosizioneRifiuto,
          idCantiereFuoriUl: this.itemData.idCantiere
        }
        this.idDestinatario = this.itemData.idDestinatario;
        this.idMagazzino = this.itemData.idMagazzino;
        this.idPosizioneRifiuto = this.itemData.idPosizioneRifiuto;
        this.idCantiereFuoriUl = this.itemData.idCantiere;
        //this.myfilterDett="?idDestinatario=0&idMagazzino=0&idPosizioneRifiuto=0&idCantiereFuoriUl="
        //this.executeQueryGrigiaGiacenzeIniziali();
      }
    }
    // this.formGiacenzeIniziali.parent=this;

  }

  async callabckFunction(e) {
    return {
      result: true, message: ''
    };
  }

  executeQueryGrigiaGiacenzeIniziali() {

    if (!this.gridGiacenzeIniziali) return;
    this.gridGiacenzeIniziali.costantValues = [
      { key: 'IdDestinatario', value: this.idDestinatario },
      { key: 'IdMagazzino', value: this.idMagazzino },
      { key: 'IdPosizioneRifiuto', value: this.idPosizioneRifiuto },
      { key: 'idCantiereFuoriUl', value: this.idCantiereFuoriUl }
    ]
    if (this.idMagazzino == null) this.idMagazzino = 0;
    if (this.idPosizioneRifiuto == null) this.idPosizioneRifiuto = 0;

    if (this.idCantiereFuoriUl)
      this.myfilterDett = "?idDestinatario=" + this.idDestinatario + "&idMagazzino=" + this.idMagazzino + "&idPosizioneRifiuto=" + this.idPosizioneRifiuto + "&idCantiereFuoriUl=" + this.idCantiereFuoriUl
    else this.myfilterDett = "?idDestinatario=" + this.idDestinatario + "&idMagazzino=" + this.idMagazzino + "&idPosizioneRifiuto=" + this.idPosizioneRifiuto + "&idCantiereFuoriUl="
    //this.myfilterDett+="&load=true"
    this.gridGiacenzeIniziali.filter = this.myfilterDett
    this.gridGiacenzeIniziali.refresh();

  }

  emettiChiusuraCaption() {
    this.userComponentService.destroyCurrentOpenPopUpByGuid(this.guid)
  }
  emittendButtonPushInFormEdit(e) {
    if (e.name == 'onInitNewRow') {
      //alert("wwwwwwwwwwww","wwwwwwwwwwwwww")
      /*console.log("data ",this.formGiacenzeIniziali.formEdit.formData);
      console.log("data e",e);
      e.component.cancel=true;
      e.component.cancelEditData();
      e.component.refresh();*/
    }


    if (e.name == 'onRowValidating') {
      if (e.oldData && e.oldData.quantitaKgScaricata) {
        if (e.newData && e.newData.quantitaKg) {
          if (e.newData.quantitaKg < e.oldData.quantitaKgScaricata) {
            alert("ATTENZIONE !! La quantita è inferiore a quella scaricata", "ERRORE GICENZA")
            //e.isValid=false;

            e.newData.quantitaKg = e.oldData.quantitaKg;
            e.componet.cancelEditData();
            return;
          }
        }
      }

    }


    if (e.name == 'formContentInitializzed') {
      console.log("Ecco formContentInitializzed ", e)
    }
    if (e.name == 'formContentReady') {
      console.log("Ecco formContentReady ", e)
      //e.masterComponent.itemOption('giacenze.idCantiere','visible',false) 



    }



    if (e.name == 'selectedItemLista') {
      if (e.dataField == 'idDestinatario') {
        if (e.valore > 0) {
          this.appService.GetApi('Cantiere/' + e.valore).then(res => {
            if (res && res['items'] && res['items'].length > 0) {

              //e.masterComponent.getEditor("idCantiere").option("disabled",false)

              //this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.idCantiere','visible',true)
              //this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.NoType','visible',false)

            } else {
              if (e && e.masterComponent && e.masterComponent.getEditor("idCantiere")) e.masterComponent.getEditor("idCantiere").option("disabled", true)
              //this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.idCantiere','visible',false)
              //this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.NoType','visible',true)

            }
            //let editCantiere=this.formGiacenzeIniziali.formEdit.instance.getEditor("idCantiere");
            //editCantiere.option("visible",(res['items'].length>0)?true:false);
            //this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.idCantiere','visible',false)
            //NoType
          })
        }
      }
    }


    if (e.name == 'formContentInitializzed') {
      if (this.insertRecord) {
        e.component.itemOption('giacenze.eer', 'disabled', false)

        // let editorUploadButton = e.component.getEditor("eer");
        //editorUploadButton.option("disabled",false);


      } else e.component.itemOption('giacenze.eer', 'disabled', true)
    }

    console.log('emittendButtonPushInFormEdit ', e)

    if (e.name == "buttonNewRowEvent") {
      console.log("Validazione ", this.formGiacenzeIniziali.formEdit.instance.validate());
      if (!this.formGiacenzeIniziali.formEdit.instance.validate().isValid) {
        alert("ATTENZIONE! Inserire i valori obbligatori  ", "Giacenze Iniziali")
        e.cancel = true;
        //e.dynamicGridComponentinstance.cancelEditData();
        //e.dynamicGridComponentinstance.refresh();
        return e;
      }
      return e;
      e.dynamicGridComponentinstance.addRow();
      //e.dynamicGridComponentinstance.editRow(rowIndex)
      // e.cancel = true;
      // e.masterComponent.cancelEditData()
    }

    if (e.eventName == 'submittedEditOk' || e.eventName == 'submittedInsertOk' || e.name == 'return') {
      this.inEdit = false;
      this.insertRecord = false;
      if (this.gridGiacenzeIniziali) this.gridGiacenzeIniziali.refresh();
      if (this.ChiudiDopoModifica == true) {
        this._overlaySideFormService.close();
      }

    }
    //formDataInit
    if (e.name == 'grigliaCambiata') {
      let giascar = 0;
      //check is movimentatodd
      e.dataSource.forEach(element => {
        giascar += element.quantitaKgScaricata
      })
      //
      //giascar=10
      if (giascar > 0) {

        let editorUploadButton = e.component.getEditor("idStatoFisico");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idTipoCarico");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("riferimentoEER");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idPosizioneRifiuto");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idMagazzino");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idCantiereFuoriUl");
        editorUploadButton.option("disabled", true);


        editorUploadButton = e.component.getEditor("idDestinatario");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idTipoCarico");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("listaHP");
        editorUploadButton.option("disabled", true);

        editorUploadButton = e.component.getEditor("idProvenienzaGiacenza");
        editorUploadButton.option("disabled", true);

        // e.masterComponet.itemOption('giacenze.riferimentoEER','disabled',true)
        // e.masterComponet.itemOption('giacenze.idStatoFisico','disabled',true)
        // e.masterComponet.itemOption('giacenze.idTipoCarico','disabled',true)                

      }
    }
  }
  emittendButtonPush(e) {

    if (e.name == 'ValueChangedLista') {
      if (e.campo.dataField == "idCantiereFuoriUl") {
        if (e.value == null) {
          this.idCantiereFuoriUl = e.value
          this.executeQueryGrigiaGiacenzeIniziali();
        }
      }

    }

    if (e.name == 'selectedItemLista') {
      if (e.dataField == 'idDestinatario') {
        if (e.valore > 0) {
          this.appService.GetApi('Cantiere/' + e.valore).then(res => {
            if (res && res['items'] && res['items'].length > 0) {
              this.formGiacenzeInizialiFiltro.formEdit.instance.itemOption('giacenzeFiltro.idCantiereFuoriUl', 'visible', true)
              this.formGiacenzeInizialiFiltro.formEdit.instance.itemOption('giacenzeFiltro.NoType', 'visible', false)

            } else {
              this.formGiacenzeInizialiFiltro.formEdit.instance.itemOption('giacenzeFiltro.idCantiereFuoriUl', 'visible', false)
              this.formGiacenzeInizialiFiltro.formEdit.instance.itemOption('giacenzeFiltro.NoType', 'visible', true)

            }
          })
        }
      }
    }




    //
    //submittedInsertOk submittedEditOk onSavingonFormSubmit 
    if (e == "elaboraFiltroChiudi") {
      this._overlaySideFormService.close();
    }

    if (e.name == "selectedItemLista") {
      let Field = e.dataField;
      let value = e.valore;
      this[Field] = value;
      //if(Field=='idDestinatario'){ this.idMagazzino=0;this.idCantiereFuoriUl=null}
      this.executeQueryGrigiaGiacenzeIniziali();
    }



    if (e.name == "elaboraFiltro" || e == 'elaboraFiltro') {
      let dati = this.formGiacenzeInizialiFiltro.formEdit.formData;
      console.log(dati)

      this.gridGiacenzeIniziali.costantValues = [
        { key: 'IdDestinatario', value: dati.idDestinatario },
        { key: 'IdMagazzino', value: dati.idMagazzino },
        { key: 'IdPosizioneRifiuto', value: dati.idPosizioneRifiuto },
        { key: 'idCantiereFuoriUl', value: dati.idCantiere }
      ]
      this.myfilterDett = "?idDestinatario=" + dati.idDestinatario + "&idMagazzino=" + dati.idMagazzino + "&idPosizioneRifiuto=" + dati.idPosizioneRifiuto + "&idCantiere=" + dati.idCantiere
      this.gridGiacenzeIniziali.filter = this.myfilterDett
      this.gridGiacenzeIniziali.refresh();





    }
    if (e.eventName == 'onSavingonFormSubmit') {
      return false;
    }
    if (e.eventName == 'submittedInsertOk' || e.eventName == 'submittedEditOk') {
      this.inEdit = false;
      this.insertRecord = false;
      if (this.ChiudiDopoModifica == true) {
        this._overlaySideFormService.close();
      }

      //this._overlaySideFormService.close();
    }
    if (e.name == 'return') {
      this.inEdit = false;
      this.insertRecord = false;
      if (this.ChiudiDopoModifica == true) {
        this._overlaySideFormService.close();
      }

      //this._overlaySideFormService.close();
    }
    if (e.name == 'beforeSavingDynamiGrid') {

      if (e.data) {
        if (e.event.changes)
          if (e.event.changes.length > 0)
            if (e.event.changes[0].data.quantitaKg)
              if (e.event.changes[0].data.quantitaKg < e.data.quantitaKgScaricata) {
                alert("Quantita Carico Inferiore a quella Scaricata", "Carico Giacenze");
                e.event.cancel = true;
              }
      } else {
        if (e.event.changes)
          if (e.event.changes.length > 0)
            if (e.event.changes[0].type == 'remove')
              if (e.event.changes[0].key.quantitaKgScaricata > 0) {
                alert("Non è possibile Eliminare la Giacenza", "Carico Giacenze");
                e.event.changes = [];
                e.event.cancel = true;
                setTimeout(() => {
                  e.event.component.cancelEditData()
                  e.event.component.refresh();
                }, 200);


                //repaintRows

              }
      }
      console.log('EVENTO DA FORM ', e)
      // controlli prima di save o edit o cancel
      //e.event.cancel=true;
    }

    console.log(e)
  }
  AllEvent(e) {
    console.log(e)//

    if (e.name == 'onLoading') {
      console.log("onLoading ", e)
    }

    if (e.name == "onCellPrepared") {

      if (e.rowType === "data" && e.dataField == "idStatoFisico") {
        e.cellElement.innerHTML = e.value + " - " + e.text;

        console.log("ecco EERRRRR IN onCellPrepared", e)


      }

      if (e.rowType === "data" && e.dataField == "eer") {
        if (e.data.isPericoloso == true) {
          e.cellElement.innerHTML += "<span style='color:red'>*</span>";
          //e.cellElement.style.cssText = "color: white; background-color: red";
          //console.log("ecco EERRRRR IN onCellPrepared",e)
        }

      }
    }



    if (e.name == 'onInitNewRow') {
      if (!this.formGiacenzeInizialiFiltro.formEdit.instance.validate().isValid) {
        e.cancel = true;
        return;
      }
      this.insertRecord = true;
      e.cancel = true;
      this.datiJson = {};
      this.datiJson = {
        idDestinatario: this.idDestinatario,
        idMagazzino: this.idMagazzino,
        idPosizioneRifiuto: this.idPosizioneRifiuto,
        idCantiereFuoriUl: this.idCantiereFuoriUl,
      }
      this.filterKey = ""
      /*
         
      this.formGiacenzeIniziali.dataJson=null;
      this.formGiacenzeIniziali.formEdit.instance.itemOption('giacenze.eer','disabled',false)
      let editorUploadButton = this.formGiacenzeIniziali.formEdit.instance.getEditor("eer");
      editorUploadButton.option("disabled",false);     
      this.formGiacenzeIniziali.formEdit.instance.updateData('idPosizione', this.idPosizione);
      this.formGiacenzeIniziali.formEdit.instance.updateData('idDestinatario', this.idDestinatario);
      this.formGiacenzeIniziali.formEdit.instance.updateData('idMagazzino', this.idMagazzino);

      this.formGiacenzeIniziali.formEdit.instance.repaint();// formRefresh(this.filterKey);
*/
      //this.formGiacenzeIniziali.formEdit.instance.updateData(this.datiJson)
      //this.formGiacenzeIniziali.formRefresh(this.filterKey);
      this.inEdit = true
      console.log("ECCO I DATI ", e.data)
    }
    if (e.name == 'onEditorPrepared') {
      e.cancel = true;
      this.datiJson = e.data;
      this.filterKey = "/" + this.datiJson.id

      //this.formGiacenzeIniziali.formRefresh(this.filterKey);
      this.inEdit = true
      this.insertRecord = false;
      console.log("ECCO I DATI ", e.data)
    }
  }
}
